import { Parser } from 'json2csv';
import downloadFile from './download';
import moment from 'moment';
import _ from 'lodash';

export function getCsv(data, dateFormat = 'D MMM YYYY hh:mm A') {
  const allUsers = _(data)
    .map(d => d.users)
    .flatten()
    .groupBy('userId')
    .map(users => ({ name: users[0].name, email: users[0].email, userId: users[0].userId }))
    .sortBy('name')
    .value();

  const fields = [
    { label: 'Name', value: 'name' },
    { label: 'Label', value: 'label' },
    { label: 'Created At', value: 'createdAt' },
    { label: 'Created By', value: 'createdBy' },
    { label: 'Updated At', value: 'modifiedAt' },
    { label: 'Updated By', value: 'updatedBy' },
    { label: 'Accessed At', value: 'accessedAt' },
    { label: 'Accessed By', value: 'accessedBy' },
    ..._.map(allUsers, u => ({ label: `${u.name} (${u.email})`, value: u.userId }))
  ];

  const mergedData = _(data).map(d => {
    const data = {
      ...d,
      createdAt: moment(d.createdAt).format(dateFormat),
      createdBy: d.createdBy ? `${d.createdBy.name} (${d.createdBy.email}) ` : '',
      modifiedAt: moment(d.modifiedAt).format(dateFormat),
      updatedBy: d.updatedBy ? `${d.updatedBy.name} (${d.updatedBy.email}) ` : '',
      accessedAt: moment(d.accessedAt).format(dateFormat),
      accessedBy: d.accessedBy ? `${d.accessedBy.name} (${d.accessedBy.email}) ` : '',
    };

    _(d.users).forEach(u => {
      const val = [];
      if (u.view) val.push('VIEW'); 
      if (u.edit) val.push('EDIT'); 
      if (u.delete) val.push('DELETE');
      data[u.userId] = val.join(' | ');
    })

    return data;
  }).value();

  const json2csvParser = new Parser({ fields });
  const csv = json2csvParser.parse(mergedData);

  return csv;
}

export function saveCsv(data) {
  const csv = getCsv(data);
  const filename = `dashboards_${moment().format('YYYY-M-D')}.csv`;
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  downloadFile(url, filename);
}